import type { RichTextPanelItem } from '@vedalib/editor/lib/elements'
import { createItem } from '@vedalib/editor/lib/elements/elements/Accordion/constants'
import React from 'react'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldArray, FieldSegmented, FormField } from 'components/formKit'
import { t } from 'services/Translation'

import { useThroughElementItemsArrayEffect } from '../../utils/formEffects'
import AccordionFormValueItem from './AccordionFormValueItem'
import type { AccordionValueFormType } from './accordionTypes'

const SHOW_FIRST_TAB = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showFirstTab',
  label: t('elements.accordion.form.showFirstTab'),
  defaultValue: false,
  info: t('elements.accordion.form.firstTabInfo'),
})

const MULTIPLE_EXPAND = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'multipleExpand',
  label: t('elements.accordion.form.multipleExpand'),
  defaultValue: true,
  info: t('elements.accordion.form.multipleExpandInfo'),
})

const ITEMS = genElementValueField({
  as: FieldArray<RichTextPanelItem>,
  name: 'items',
  props: {
    defaultItem: createItem(),
    RenderItem: AccordionFormValueItem,
    min: 1,
  },
  useConfigs: [useThroughElementItemsArrayEffect],
})

const AccordionFormValue: AccordionValueFormType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, SHOW_FIRST_TAB)} />
      <FormField config={chainName(name, MULTIPLE_EXPAND)} />
      <FormField config={chainName(name, ITEMS)} />
    </Padding>
  )
}

export default React.memo(AccordionFormValue) as typeof AccordionFormValue
